import urlencode from 'urlencode'
//局部显露
export const mixin = {
    data () {
        return {
            wxAppId:'wxcd032fdf22dc5924',
            url: 'http://test-9gameh5.laolongtang.com.cn/callback.html'
        }
    },
    methods:{
        toWxAuth (state)
        {
            let REDIRECT_URI=encodeURIComponent(this.url)
            let wxAuthUrl='https://open.weixin.qq.com/connect/oauth2/authorize?appid='+this.wxAppId+'&redirect_uri='+REDIRECT_URI+'&response_type=code&scope=snsapi_userinfo&state='+state+'&connect_redirect=1#wechat_redirect'
            window.location.href=wxAuthUrl
        }
    }
    // mounted(){
    //     console.log('来了2')
    // }
}

// export const mixin2 = {
//     methods:{
//         showAddress(){
//             alert(this.address)
//         }
//     },
//     mounted(){
//         console.log('来了2')
//     }
// }